import { render, staticRenderFns } from "./ImpersonatingNavBar.vue?vue&type=template&id=5065b84f&scoped=true&"
import script from "./ImpersonatingNavBar.vue?vue&type=script&lang=js&"
export * from "./ImpersonatingNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065b84f",
  null
  
)

export default component.exports